var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#002400;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1979",
    "data-name": "Group 1979"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_225",
    "data-name": "Ellipse 225",
    className: "cls-1",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    className: "cls-2",
    d: "M23.26,8.15H11.75a3.58,3.58,0,0,0-3.6,3.56V23.26a3.58,3.58,0,0,0,3.56,3.6H23.26a3.59,3.59,0,0,0,3.6-3.57V11.75a3.59,3.59,0,0,0-3.57-3.6Zm1,2.16h.4v3.2h-3.2v-3.2Zm-9.43,5.27a3.24,3.24,0,0,1,4.52-.75,3.18,3.18,0,0,1,.76.75,3.33,3.33,0,0,1,.64,1.92,3.28,3.28,0,0,1-6.56,0,3.33,3.33,0,0,1,.64-1.92ZM25,23.26A1.77,1.77,0,0,1,23.26,25H11.75A1.78,1.78,0,0,1,10,23.26V15.58h2.8a5.12,5.12,0,0,0,9.43,4,5.16,5.16,0,0,0,0-4H25Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.97dfe35f293929ced42c15b5b4ad09d0.svg";
export { ForwardRef as ReactComponent };